import { useTranslation } from 'react-i18next';
import { Card, Typography } from '@mui/material';
import { Relaxation } from '../../../../icons/relaxation';
import STRING_KEYS from '../../../../language/keys';
import style from './style';

export default function EmptyTasks(): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Card sx={ style.card }>
      <Relaxation
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />
      <Typography variant="h6" >{translate(STRING_KEYS.HOME_PAGE.EMPTY_TITLE)}</Typography>
      <Typography variant="body1" >{translate(STRING_KEYS.HOME_PAGE.EMPTY_DESCRIPTION)}</Typography>
    </Card>
  );
}
